import { inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DocumentJsonService {
  headers = new HttpHeaders();

  private dataService: HttpService = inject(HttpService);

  getModuloEEVisible(): Promise<any> {
    return new Promise((resolve) => {
      let DataModuloEEVisible: any;
      this.dataService.getFile('assets/doctos/validaEE.json').subscribe((data: any) => {
        DataModuloEEVisible = data;
        resolve(DataModuloEEVisible);
      });

    });

  }
}
